export const LENOVO_EDUCATION_URL = 'https://www.lenovo.com';
